































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import ContentDialog from '@/components/content-dialog.vue';
import ConversationService from '@/services/crm/conversation.service';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import CrmChatCloseForm from './chat-close-form.vue';
import ConversationModel from '@/models/crm/conversation.model';
import ConversationUserPermissionsModel from '@/models/crm/conversation-user-permissions.model';
import OriginModel from '@/models/crm/origin.model';
import HistoryTypeModel from '@/models/crm/history-type.model';
import GroupModel from '@/models/crm/group.model';
import ContactModel from '@/models/crm/contact.model';

interface IDepartmentOption {
  id: number;
  name: string;
}

interface IAttendantOption {
  id: number;
  name: string;
}

interface IChatContactFormModel {
  description: string | null;
  mistake: boolean;
  justified: boolean;
  origin: OriginModel | null;
  historyType: HistoryTypeModel | null;
  groupArea: GroupModel | null;
  consolidateSale: boolean;
  contact: ContactModel | null;
  attendantId: number | null;
  departmentId: number | null;
  transferType: string | null;
}

@Component({
  components: {
    ContentDialog,
    CrmChatCloseForm,
  },
})
class CrmChatgeochatTransferDialog extends Vue {
  @inject(InjectionIdEnum.CrmConversationService)
  protected conversationService!: ConversationService;

  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: Number, required: true })
  conversationId!: number;

  @Prop({ type: Boolean, default: false })
  forceGeochat!: boolean;

  @Prop({ type: Object, required: false, default: null })
  currentConversation!: ConversationModel;

  @Prop({ type: Object, required: false, default: null })
  conversationUserPermission!: ConversationUserPermissionsModel;

  transferType: 'whatsapp' | 'geochat' | null = null;

  selectedDepartmentId: number | null = null;

  selectedAttendantId: number | null = null;

  closeCurrentConversation = true;

  departments: IDepartmentOption[] = [];

  attendants: IAttendantOption[] = [];

  loading = false;

  showCloseForm = false;

  shouldOpenCloseForm = false;

  btnCloseNotSavingContact = '';

  closeFormModel: IChatContactFormModel = {
    description: null,
    mistake: false,
    justified: false,
    origin: null,
    historyType: null,
    groupArea: null,
    consolidateSale: false,
    contact: null,
    attendantId: null,
    departmentId: null,
    transferType: null,
  };

  get show(): boolean {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit('input', value);
  }

  // eslint-disable-next-line class-methods-use-this
  get transferTypeOptions(): Array<{ text: string; value: string }> {
    return [
      { text: 'Homologado', value: 'whatsapp' },
      { text: 'GeoChat', value: 'geochat' },
    ];
  }

  get isConfirmDisabled(): boolean {
    if (!this.transferType) return true;
    if (this.transferType === 'geochat' && (!this.selectedDepartmentId || !this.selectedAttendantId)) {
      return true;
    }
    return false;
  }

  async mounted(): Promise<void> {
    await this.loadBtnCloseNotSavingContact();
  }

  @Watch('forceGeochat', { immediate: true })
  onForceGeochatChange(value: boolean): void {
    if (value) {
      this.transferType = 'geochat';
    }
  }

  @Watch('transferType')
  async onTransferTypeChange(value: 'whatsapp' | 'geochat' | null): Promise<void> {
    if (value === 'geochat') {
      await this.loadDepartments();
    } else {
      this.selectedDepartmentId = null;
      this.selectedAttendantId = null;
      this.departments = [];
      this.attendants = [];
    }
  }

  async onDepartmentChange(departmentId: number): Promise<void> {
    this.selectedAttendantId = null;
    if (departmentId) {
      await this.loadAttendants(departmentId);
    }
  }

  async loadDepartments(): Promise<void> {
    this.loading = true;
    try {
      const departments = await this.conversationService.getSalesDepartments();
      this.departments = departments.map((dept) => ({
        id: dept.id,
        name: dept.nomeDepartamento,
      }));
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loading = false;
    }
  }

  async loadAttendants(departmentId: number): Promise<void> {
    this.loading = true;
    try {
      const attendants = await this.conversationService.getSalesAttendantsByDepartment(departmentId);
      this.attendants = attendants.map((att) => ({
        id: att.id,
        name: att.nome,
      }));
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loading = false;
    }
  }

  async onConfirm(): Promise<void> {
    if (!this.transferType) {
      this.$notify.error(this.$t('crm.chat.messages.selectTransferType'));
      return;
    }

    if (this.transferType === 'geochat') {
      if (!this.selectedDepartmentId) {
        this.$notify.error(this.$t('crm.chat.messages.selectDepartment'));
        return;
      }

      if (!this.selectedAttendantId) {
        this.$notify.error(this.$t('crm.chat.messages.selectAttendant'));
        return;
      }

      console.log('aqui é quando clicou pra confirmar',
        this.selectedAttendantId,
        this.selectedDepartmentId,
        this.transferType);
      if (this.closeCurrentConversation) {
        if (!this.currentConversation || !this.conversationUserPermission) {
          this.$notify.error(this.$t('crm.chat.messages.missingConversationData'));
          return;
        }
        this.closeFormModel.attendantId = this.selectedAttendantId;
        this.closeFormModel.departmentId = this.selectedDepartmentId;
        this.closeFormModel.transferType = this.transferType;
        console.log(this.closeFormModel,
          'aqui é quando colocou no formModel e vai abrir');
        this.shouldOpenCloseForm = true;
        this.show = false;
        return;
      }

      await this.performTransfer();
    } else {
      if (this.closeCurrentConversation) {
        if (!this.currentConversation || !this.conversationUserPermission) {
          this.$notify.error(this.$t('crm.chat.messages.missingConversationData'));
          return;
        }
        this.shouldOpenCloseForm = true;
        this.show = false;
        return;
      }

      await this.performTransfer();
    }
  }

  async performTransfer(): Promise<void> {
    try {
      this.loading = true;

      if (this.transferType === 'geochat') {
        await this.conversationService.transferToGeochat(
          this.conversationId,
          this.selectedDepartmentId,
          this.selectedAttendantId,
          false,
        );
      } else {
        await this.conversationService.transferToGeochat(
          this.conversationId,
          null,
          null,
          true,
        );
      }

      this.$notify.success(this.$t('crm.chatCloseForm.messages.successfullyTransfered'));
      this.$emit('success');
      this.show = false;
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loading = false;
    }
  }

  async performTransferWithCloseData(closeFormData: IChatContactFormModel): Promise<void> {
    if (!this.currentConversation) {
      this.$notify.error(this.$t('crm.chat.messages.missingConversationData'));
      return;
    }

    try {
      this.loading = true;

      console.log(closeFormData, this.transferType);
      if (closeFormData.transferType === 'geochat') {
        await this.conversationService.transferToGeochat(
          this.conversationId,
          closeFormData.departmentId,
          closeFormData.attendantId,
          false,
        );

        if (this.closeCurrentConversation) {
          await this.conversationService.closeConversation(
            this.currentConversation,
            closeFormData.mistake,
            closeFormData.justified,
            closeFormData.description as string,
            closeFormData.origin as OriginModel,
            closeFormData.historyType as HistoryTypeModel,
            closeFormData.consolidateSale,
            closeFormData.contact?.id as number,
          );
        }
      } else {
        await this.conversationService.transferToGeochat(
          this.conversationId,
          null,
          null,
          true,
        );

        if (this.closeCurrentConversation) {
          await this.conversationService.closeConversation(
            this.currentConversation,
            closeFormData.mistake,
            closeFormData.justified,
            closeFormData.description as string,
            closeFormData.origin as OriginModel,
            closeFormData.historyType as HistoryTypeModel,
            closeFormData.consolidateSale,
            closeFormData.contact?.id as number,
          );
        }
      }

      this.$notify.success(this.$t('crm.chatCloseForm.messages.successfullyTransfered'));
      this.$emit('success');
      this.showCloseForm = false;
      this.onClose();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      this.loading = false;
    }
  }

  async onCloseFormSave(): Promise<void> {
    const closeFormComponent = this.$refs.closeForm as Vue & { $refs: { form: Vue & { validate(): boolean } } };
    if (closeFormComponent && closeFormComponent.$refs.form) {
      const isValid = closeFormComponent.$refs.form.validate();
      if (!isValid) {
        this.$notify.error(this.$t('crm.chatCloseForm.messages.fillRequiredFields'));
        return;
      }
    }
    await this.performTransferWithCloseData(this.closeFormModel);
  }

  onCloseFormCancel(): void {
    this.showCloseForm = false;
    this.onClose();
  }

  onAfterTransferDialogClose(): void {
    if (this.shouldOpenCloseForm) {
      this.shouldOpenCloseForm = false;
      this.showCloseForm = true;
      return;
    }

    this.onClose();
  }

  onClose(): void {
    this.transferType = null;
    this.selectedDepartmentId = null;
    this.selectedAttendantId = null;
    this.closeCurrentConversation = true;
    this.departments = [];
    this.attendants = [];
    this.shouldOpenCloseForm = false;
    this.closeFormModel = {
      description: null,
      mistake: false,
      justified: false,
      origin: null,
      historyType: null,
      groupArea: null,
      consolidateSale: false,
      contact: null,
      attendantId: null,
      departmentId: null,
      transferType: null,
    };
  }

  private async loadBtnCloseNotSavingContact(): Promise<void> {
    this.btnCloseNotSavingContact = await this.conversationService.getBtnCloseNotSavingContact();
  }
}

export default CrmChatgeochatTransferDialog;
